module.exports = __webpack_public_path__ + "static/media/darkBG.c46605a9.png";